import gsap from 'gsap'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const logoWallRevealAnimation = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const cards = selector('[data-motion-logo]')

  batchRevealAnimation({
    targets: cards,
    reverse,
    stagger: {
      amount: 0.3
    }
  })
}
